<template>
  <div class="notes">
    <the-sidebar class="notes-sidebar"/>
    <div class="notes-main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import TheSidebar from '@/components/sidebar/TheSidebar.vue';

export default {
  name: 'TheNotes',
  components: {
    TheSidebar,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

$sidebar-width: 24rem;

.notes {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  &-sidebar {
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
    width: $sidebar-width;
  }

  &-main {
    bottom: 0;
    left: $sidebar-width;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
